import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { EventScoreboard } from '@frontend/sports/betting-offer/feature/model';

import { LiveTimerComponent } from './live-timer.component';
import { PrematchTimerComponent } from './prematch-timer.component';

@Component({
    selector: 'ms-event-timer',
    templateUrl: './event-timer.component.html',
    styleUrl: 'event-timer.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [LiveTimerComponent, PrematchTimerComponent],
})
export class EventTimerComponent {
    @Input() live: boolean;
    @Input() start: Date;
    @Input() scoreboard: EventScoreboard;
    @Input() isDynamicTimer: boolean;
    @Input() intervalForRedPrematchTimer: number;
    @Input() calendarInfoDisplay = false;
    @Input() timeValue?: string;
    @Input() eventId?: number;
    @Input() scoreboardType: string;
}
